<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    :id="element.id"
    class="tw-plain-element"
    :style="element.style"
    v-bind="{ ...$attrs, ...element.attr }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import type { Element as ElementType } from '../../types/model';

defineProps({
  element: { type: Object as PropType<ElementType<'plain'>>, default: () => ({}) },
});
</script>
